export const formatTimeWIB = (dateString) => {
    if (!dateString) return '-'
  
    const date = new Date(dateString)
  
    return new Intl.DateTimeFormat('id-ID', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: 'Asia/Jakarta',
    })
      .format(date)
      .replace(':', '.') + ' WIB'
  }